// extracted by mini-css-extract-plugin
export default {"cartContainer":"Cart_cartContainer__10Kxs","cartTitle":"Cart_cartTitle__auakD"};